/* Afkar Plus — "The Afkar index" carousel (BeyondADS, 23 Sep 2026) */
(function () {
  'use strict';
  if (window.__afxLoaded) return;
  window.__afxLoaded = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function init(root) {
    if (root.__afx) return;
    root.__afx = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-afx-item]'));
    var n = items.length;
    if (!n) return;
    var cur = root.querySelector('[data-afx-cur]');
    var auto = root.getAttribute('data-auto') === 'true';
    var dur = Math.max(2, parseInt(root.getAttribute('data-interval'), 10) || 3) * 1000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = Math.min(n - 1, Math.max(0, (parseInt(root.getAttribute('data-start'), 10) || 1) - 1));
    var timer = null, paused = false;

    function render() {
      items.forEach(function (el, k) {
        var d = (k - i + n) % n;
        el.classList.remove('is-active', 'is-left', 'is-right', 'is-r2', 'is-hidden', 'is-out');
        if (d === 0) el.classList.add('is-active');
        else if (d === 1) el.classList.add('is-right');
        else if (d === n - 1) el.classList.add('is-left');
        else if (d === 2 && n > 3) el.classList.add('is-r2');
        else { el.classList.add('is-hidden'); if (d === n - 2) el.classList.add('is-out'); }
        el.setAttribute('aria-current', d === 0 ? 'true' : 'false');
      });
      if (cur) cur.textContent = pad(i + 1);
    }
    function go(k) { i = ((k % n) + n) % n; render(); restart(); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() {
      stop();
      if (!auto || reduce || n < 2 || paused) return;
      timer = setInterval(function () { if (document.hidden) return; i = (i + 1) % n; render(); }, dur);
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-afx-prev],[data-afx-next]');
      if (b) { e.preventDefault(); go(i + (b.hasAttribute('data-afx-next') ? 1 : -1)); return; }
      var it = e.target.closest('[data-afx-item]');
      if (it && !it.classList.contains('is-active')) { e.preventDefault(); go(parseInt(it.getAttribute('data-afx-item'), 10) || 0); }
    });
    /* no hover pause: the client wants the 3 s rotation to run wherever the cursor is */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
    });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });

    render();
    restart();
    root.__afxGo = go;
  }

  function boot() { document.querySelectorAll('[data-afx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
